export default "__VITE_ASSET__DZ5lm3qS__"